import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-refund-request-details',
  templateUrl: './refund-request-details.component.html',
  styleUrls: ['./refund-request-details.component.css']
})
export class RefundRequestDetailsComponent implements OnInit {

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<RefundRequestDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

